import get from 'lodash/get';

export default function getResubscriptionCurrencies(state: any): string[] {
  return get(state, 'page.data.zone.resubscriptionConfig.currencies', []);
}
